import { rpcClient } from "@/api/WebsocketClient"
import { reactive } from '@vue/reactivity'
import Offer from '@/model/Offer';
import { organizationStore } from '@/store/OrganizationStore';

export default class GeneratedOfferStore {

    state = reactive({
        offers: new Map<number, Offer>(),
        calls: new Map<string, number | number[]>()
    })

    constructor() {
        this.init()
    }

    init() {
        window.setTimeout(() => {
            if (rpcClient) {
                rpcClient.stores.push(this)
            } else {
                this.init()
            }
        }, 1)
    }

    clearState() {
        if (this.state?.offers) this.state.offers.clear()
        if (this.state?.calls) this.state.calls.clear()
    }

    addOrReplaceOffer(newOffer: Offer) {
        if (newOffer.id) {
            this.state.offers.set(newOffer.id, newOffer)
            if (newOffer.organization) {
                organizationStore.addOrReplaceOrganization(newOffer.organization)
            }

        }
    }

    addOrReplaceOffers(newOffers: Offer[]) {
        for (const newOffer of newOffers) {
            this.addOrReplaceOffer(newOffer)
        }
    }

    replaceOffers(offers: Offer[]) {
        const newOffers = new Map<number, Offer>()
        for (const newOffer of offers) {
            if (newOffer.id) {
                newOffers.set(newOffer.id, newOffer)
                if (newOffer.organization) {
                organizationStore.addOrReplaceOrganization(newOffer.organization)
            }

            }
        }
        this.state.offers = newOffers
    }

    removeOffer(id: number | undefined | null) {
        if (id !== undefined && id !== null) {
            this.state.offers.delete(id)
        }
    }

    removeOffers(ids: (number | null)[] | undefined | null) {
        if (ids !== undefined && ids !== null) {
            for (const id of ids) {
                this.removeOffer(id)
            }
        }
    }
}